import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {SkillModel} from '../core/model/skill';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SkillsApiService {
  constructor(private http: HttpClient) {}

  private get url() {
    return `${environment.apiUrl}/requirements`;
  }

  fetchAll(search: string | null): Observable<SkillModel[]> {
    return this.http
      .get<SkillModel[]>(`${this.url}`)
      .pipe(map(skills => skills.filter(s => !search || s.name.toLowerCase().includes(search))));
  }

  getSingleSkill(id: string): Observable<SkillModel> {
    return this.http.get<SkillModel>(`${this.url}/${id}`);
  }

  saveSkill(skill: SkillModel): Observable<SkillModel> {
    if (skill._id !== 'new') {
      return this.http.put<SkillModel>(`${this.url}/${skill._id}`, skill);
    }

    delete skill._id;
    return this.http.post<SkillModel>(`${this.url}`, skill);
  }

  removeSkill(id: string): Observable<void> {
    return this.http.delete<void>(`${this.url}/${id}`);
  }
}
